export default "__VITE_ASSET__BVCkE6PS__"